import React from 'react'
import { observer } from "mobx-react-lite"
import styles from './PackLoops.module.scss'

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import LoopList from '../loops/LoopList'
import userStore from '../common/userStore';
import clsx from 'clsx';


const LoopsSwitch = observer(({model}) => {

  const setLoopState = (state) => {
    if (userStore.isAnonymous) {
      return;
    }
    model.setLoopState(state)
  }

  return <div className={styles['switch-group-wrap']}>
    <ButtonGroup disableElevation color="primary" className={styles['switch-group']}>

      <Button className={styles['switch-group-btn-left']} 
        variant={model.loopState === 'presets' ? "contained" : "outlined"} 
        onClick={() => setLoopState('presets')}>Presets</Button>

      <Button className={clsx(styles['switch-group-btn-right'])}
        disabled={userStore.isAnonymous}
        variant={model.loopState === 'myloops' ? "contained" : "outlined"}
        onClick={() => setLoopState('myloops')}>My Loops</Button>
        
    </ButtonGroup>
  </div>
})

const PackLoops = observer(({model}) => {
  return <div className={styles['root']}>
    <LoopList model={model} barStart={<LoopsSwitch model={model} />} showInstrument showCover={false} />
  </div>
})

export default PackLoops